import ReviewQuestionApiDto from "../common/dto/ReviewQuestionApiDto";

export class ReviewQuestionModel {
    public question : ReviewQuestionApiDto;
    public passed : boolean | undefined;

    constructor(question: ReviewQuestionApiDto, isPassed: boolean | undefined) {
        this.question = question;
        this.passed = isPassed;
    }
}